import { useTranslation } from "react-i18next";
import { Alert } from "../../design/primitives/Alert";
import styles from "./room.module.css";

export function StudentWaiting() {
  const { t } = useTranslation();
  return (
    <div className={styles.stage}>
      <h2>{t("room.waitingTitle")}</h2>
      <Alert tone="info">{t("room.waitingBody")}</Alert>
      <p className={styles.meta}>{t("room.noChat")}</p>
    </div>
  );
}
